import React from 'react'
import PropTypes from 'prop-types'
import styles from './FileGalleryList.scss'
import FileCountBadge from '../FileCountBadge'
import { Button, Table, Input } from 'reactstrap'
import moment from 'moment'
import { Link } from 'react-router-dom'
import Pagination from '../../components/Pagination'
import SortableTableHeader from '../../components/SortableTableHeader'
import { FaFile } from 'react-icons/lib/fa'

const isImage = file => file.mimeType && file.mimeType.indexOf('image') === 0

const sortableHeaders = {
  select: '',
  mimeType: 'Thumbnail',
  name: 'Name',
  updatedAt: 'Uploaded At',
  updatedBy: 'Updated By',
  lastUsed: 'Last Used'
}

const FileGalleryList = props => <div className={styles.FileGalleryList}>
  {props.isLoading && 'Loading ...'}
  {(!props.isLoading && (!props.rows || (props && props.rows && props.rows.length === 0))) && <p className={styles.empty}>No files found.</p>}
  <Table>
    <thead>
      <tr>
        {
          Object.keys(sortableHeaders).map(type => {
            if (type === 'select' && !props.onRowSelect) return
            return <SortableTableHeader key={type} type={type}
              label={sortableHeaders[type]}
              onClick={props.onSorts[type]}
              sortDirection={props.sortDirection}
              sortBy={props.sortBy} />
          })
        }
        <th />
      </tr>
    </thead>
    <tbody>
      {props.rows.map((row, i) =>
        <tr key={i}>
          {props.onRowSelect && <td>
            <Input className={styles.checkbox} type='checkbox' checked={props.rowsSelected.find(item => item.id === row.id)} onChange={e => props.onRowSelect(e, row)} />
          </td>}
          <td>
            {
              isImage(row)
                ? <div>
                  {row.errorLoading
                    ? <div>
                      <div><Link to={`/files/${row.id}/replace`}><strong>{row.originalName}</strong></Link></div>
                      <div>⚠️ Error loading</div>
                    </div>
                    : <Link to={`/files/${row.id}/replace`}><img
                      onError={e => { return props.onSetRowAttribute(e, i, 'errorLoading', true) }}
                      style={{ maxWidth: '100px', maxHeight: '100px' }}
                      src={row.location} alt={row.originalName} title={row.originalName} /></Link>
                  }
                </div>
                : <Link to={`/files/${row.id}/replace`}><FaFile /> {row.originalName}</Link>
            }
          </td>
          <td><Link to={`/files/${row.id}/replace`}>{row.originalName}</Link></td>
          <td>{moment(row.updatedAt).fromNow()}</td>
          <td>{row.updatedBy ? `${(row.updatedBy.firstName || row.updatedBy.lastName) ? row.updatedBy.firstName + ' ' + row.updatedBy.lastName : row.updatedBy.email}` : '-'}</td>
          <td>
            {row.lastUsed && moment(row.lastUsed).fromNow()}
            {
              row.pages && row.pages.map(page =>
                <div key={page.id}>
                  <Link to={`/pages/edit/${page.id}`}>
                    {page.path}</Link>
                  {' '}<FileCountBadge count={page.fileCount} />
                </div>
              )
            }
          </td>
          {!props.hideSelect && <td>
            <Button onClick={e => { props.onSelect(e, row) }}>
              {
                typeof props.onSelectText === 'function'
                  ? props.onSelectText(row)
                  : 'Select'
              }
            </Button>
          </td>}
        </tr>
      )}
    </tbody>
  </Table>

  <Pagination
    total={props.total}
    limit={props.limit}
    history={props.history}
    match={props.match} />

  {false && <div className='debug-block'>
    <pre>{JSON.stringify(props, null, 4)}</pre>
  </div>}

</div>

FileGalleryList.propTypes = {
  sortBy: PropTypes.string,
  total: PropTypes.number,
  limit: PropTypes.number,
  isLoading: PropTypes.bool,
  history: PropTypes.object,
  match: PropTypes.object,
  rows: PropTypes.array,
  onSelectText: PropTypes.func
}

export default FileGalleryList



// WEBPACK FOOTER //
// ./src/components/FileGalleryList/FileGalleryList.js